import { Helmet } from "react-helmet-async";
import { useI18n } from "@/i18n/I18nProvider";
import { LOCALES, LOCALE_META, localizePath, SITE_URL } from "@/i18n/config";

/** Canonical URL for the current language plus hreflang links to the others. */
const SeoAlternates = ({ path }: { path: string }) => {
  const { locale } = useI18n();
  const url = (l: (typeof LOCALES)[number]) => `${SITE_URL}${localizePath(path, l)}`;
  return (
    <Helmet>
      <link rel="canonical" href={url(locale)} />
      {LOCALES.map((l) => (
        <link key={l} rel="alternate" hrefLang={LOCALE_META[l].htmlLang} href={url(l)} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={url("en")} />
      <meta property="og:url" content={url(locale)} />
      <meta property="og:locale" content={LOCALE_META[locale].ogLocale} />
    </Helmet>
  );
};

export default SeoAlternates;
